import { t } from "i18next";
import DBModal from "../../../../component/global/DBModal";
import DBInput from "../../../../component/global/DBInput";
import DBModalTitle from "../../../../component/global/DbModalTitle";
import DBFieldBlock from "../../../../component/global/DBFieldBlock";
import TreeSearchSelect from "./../../../../component/global/TreeSearchSelect/index";
import DBSelect from "../../../../component/global/DBSelect";
import DBButton from "../../../../component/global/DBButton";
import DBTextArea from "../../../../component/global/DBTextArea";
import { useContext, useEffect, useRef, useState } from "react";
import { useRequest } from "../../../../hooks/helperData/useRequest";
import {
    GET_AUTOMATION_GROUP_LIST,
    SETTING_ITEMS_TYPE,
    SETTING_ITEMS_TYPE_TREE,
} from "../../../../helperData/ApiAddress";
import { normalizeTreeResponse } from "../../../../component/global/DBSearchableTree/treeUtils";
import DBSpinner from "../../../../component/global/DBSpinner";
import DBAddButton from "../../../../component/global/DBAddButton";
import LanguageTable from "./LanguageTable";
import { ToastContext } from "../../../../component/global/ToastContext";
import IncentiveQuickSetup, {
    createQuickIncentive,
    defaultQuickSetup,
} from "../../../../features/incentives/IncentiveQuickSetup";
import DBSwitch from "../../../../component/global/DBSwitch";
import DBUpload from "../../../../component/global/DBUpload";
import { toBase64 } from "../../../../feedback/helperFunctions";

export default function ItemTypeModal({
    showModal,
    onHide,
    onSuccess,
    editMode,
}) {
    const toast = useContext(ToastContext);
    const [quickSetup, setQuickSetup] = useState(() =>
        defaultQuickSetup("item_type")
    );
    const [partialTarget, setPartialTarget] = useState(null);
    const [quickSaving, setQuickSaving] = useState(false);

    const [form, setForm] = useState({
        name: "",
        description: "",
        parent: undefined,
        typ: {
            value: 1,
            label: t("item.type.item"),
        },
        translates: [],
        weight: "1",

        close_feedback_status_groups: undefined,
        new_feedback_status_group: undefined,
        has_shared_photo: false,
        photo: undefined,
    });

    const [formErr, setFormErr] = useState({
        name: "",
        weight: "",
        close_feedback_status_groups: "",
        new_feedback_status_group: "",
        photo: "",
    });

    const [language, setLanguage] = useState({
        name: "",
        language: "en",
    });
    const [languageEditMode, setLanguageEditMode] = useState(false);

    const [itemTypes, setItemtypes] = useState([]);
    const [automationGroups, setAutomationGroups] = useState([]);

    const itemTypeType = [
        {
            value: 1,
            label: t("item.type.item"),
        },
        {
            value: 2,
            label: t("item.type.service"),
        },
    ];

    const [getCompanyList, companyListLoader] = useRequest(
        SETTING_ITEMS_TYPE_TREE,
        "GET"
    );

    const [getAutomationGroups, automationGroupsLoader] = useRequest(
        GET_AUTOMATION_GROUP_LIST.replace(
            "{id}",
            sessionStorage.getItem("usercompany")
        ),
        "GET"
    );

    const [sendItemType, sendItemTypeLoader] = useRequest(
        SETTING_ITEMS_TYPE + (editMode ? `${editMode}/` : ""),
        editMode ? "PUT" : "POST"
    );

    const [getItemType, getItemTypeLoader] = useRequest(
        SETTING_ITEMS_TYPE + editMode + "/",
        "GET"
    );

    useEffect(() => {
        if (showModal) {
            setQuickSetup(defaultQuickSetup("item_type"));
            setPartialTarget(null);
            Promise.all([
                getCompanyList().then((r) => {
                    setItemtypes(normalizeTreeResponse(r));
                }),
                getAutomationGroups().then((r) => {
                    setAutomationGroups(r);
                }),
            ]).then(() => {
                if (editMode) {
                    getItemType().then((r) => {
                        setForm({
                            name: r.name,
                            description: r.description,
                            parent: r.parent,
                            typ: r.typ,
                            translates: r.translates,
                            weight: r.weight + "",

                            close_feedback_status_groups:
                                r.workflows?.[0]
                                    ?.close_feedback_status_groups[0].id,
                            new_feedback_status_group:
                                r.workflows?.[0]?.new_feedback_status_group.id,
                            has_shared_photo: Boolean(r.has_shared_photo),
                            photo: r.photo || undefined,
                        });
                    });
                } else {
                    setForm({
                        name: "",
                        description: "",
                        parent: undefined,
                        typ: 1,
                        translates: [],
                        weight: "1",

                        close_feedback_status_groups: undefined,
                        new_feedback_status_group: undefined,
                        has_shared_photo: false,
                        photo: undefined,
                    });
                }
            });
            setFormErr({
                name: "",
                weight: "",
                close_feedback_status_groups: "",
                new_feedback_status_group: "",
                photo: "",
            });
        }
    }, [showModal]);

    const addLanguageHandle = () => {
        if (languageEditMode !== false) {
            setForm({
                ...form,
                translates: form.translates.map((item, index) =>
                    index === languageEditMode ? language : item
                ),
            });
            setLanguageEditMode(false);
            setLanguage({
                name: "",
                language: "en",
            });
        } else {
            if (
                !form.translates.some(
                    (item) => item.language === language.language
                )
            ) {
                setForm({
                    ...form,
                    translates: [...form.translates, language],
                });
                setLanguage({
                    name: "",
                    language: "en",
                });
            }
        }
    };

    const deleteLanguageHandle = (index) => {
        setForm({
            ...form,
            translates: form.translates.filter((_, ind) => ind !== index),
        });
    };

    const editLanguageHandle = (index) => {
        setLanguage(form.translates.find((_, ind) => ind === index));
        setLanguageEditMode(index);
    };

    const addEditItemType = () => {
        let formErrTemp = {};

        if (form.name.trim() === "") {
            formErrTemp = { ...formErrTemp, name: t("itemtype.name.required") };
        }
        if (form.weight.trim() === "") {
            formErrTemp = {
                ...formErrTemp,
                weight: t("itemtype.weight.required"),
            };
        }
        if (form.has_shared_photo && !form.photo) {
            formErrTemp = {
                ...formErrTemp,
                photo: t("item.type.shared.photo.required"),
            };
        }

        setFormErr(formErrTemp);

        if (Object.keys(formErrTemp).length > 0) return false;

        sendItemType({
            name: form.name,
            description: form.description,
            parent: form.parent || undefined,
            typ: form.typ,
            translates: form.translates,
            weight: form.weight,
            has_shared_photo: Boolean(form.has_shared_photo),
            photo:
                form.has_shared_photo &&
                form.photo &&
                form.photo.indexOf("http") < 0
                    ? form.photo
                    : undefined,
            workflows: [
                {
                    close_feedback_status_groups: [
                        form.close_feedback_status_groups,
                    ],
                    new_feedback_status_group: form.new_feedback_status_group,
                },
            ],
        })
            .then(async (r) => {
                const target = {
                    id: r?.id || editMode,
                    name: r?.name || form.name,
                    type: "item_type",
                };
                if (quickSetup.enabled) {
                    setQuickSaving(true);
                    try {
                        await createQuickIncentive(quickSetup, target);
                    } catch {
                        setPartialTarget(target);
                        toast(t("incentives.quick.partialTitle"), "danger");
                        return;
                    } finally {
                        setQuickSaving(false);
                    }
                }
                onHide?.();
                onSuccess?.(r);
                toast(t("itemtype.save.success"), "success");
            })
            .catch((e) => {
                toast(t("itemtype.save.error"), "danger");
            });
    };

    const retryQuickSetup = () => {
        setQuickSaving(true);
        createQuickIncentive(quickSetup, partialTarget)
            .then(() => {
                setPartialTarget(null);
                onHide?.();
                onSuccess?.(partialTarget);
                toast(t("itemtype.save.success"), "success");
            })
            .catch(() => toast(t("incentives.error.publish"), "danger"))
            .finally(() => setQuickSaving(false));
    };

    return (
        <DBModal
            permanent
            show={showModal}
            minWidth={560}
            onHide={onHide}
            className="item-type-modal"
        >
            <DBModal.Header closeBtn={onHide} title={t("create.item.type")} />

            <DBModal.Content>
                {companyListLoader ||
                automationGroupsLoader ||
                getItemTypeLoader ? (
                    <DBSpinner tip={t("loading")} />
                ) : (
                    <>
                        <DBModalTitle>
                            {t("item.type.main.fields")}
                        </DBModalTitle>
                        <div className="grid">
                            <DBFieldBlock
                                title={t("item.type.name")}
                                required
                                error={formErr.name}
                            >
                                <DBInput
                                    onClick={() =>
                                        setFormErr({ ...formErr, name: "" })
                                    }
                                    status={formErr.name && "error"}
                                    type="text"
                                    size="large"
                                    value={form.name}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            name: e.target.value,
                                        })
                                    }
                                />
                            </DBFieldBlock>
                            <DBFieldBlock title={t("item.type.parent")}>
                                <TreeSearchSelect
                                    data={itemTypes}
                                    size="large"
                                    value={form.parent}
                                    onChange={(e) =>
                                        setForm({ ...form, parent: e })
                                    }
                                />
                            </DBFieldBlock>
                            <DBFieldBlock title={t("item.type.type")} required>
                                <DBSelect
                                    options={itemTypeType}
                                    value={form.typ}
                                    onChange={(e) => {
                                        setForm({ ...form, typ: e });
                                    }}
                                    size="large"
                                />
                            </DBFieldBlock>
                            <DBFieldBlock
                                title={t("item.type.scoring")}
                                required
                                error={formErr.weight}
                            >
                                <DBInput
                                    status={formErr.weight && "error"}
                                    onClick={() =>
                                        setFormErr({ ...formErr, weight: "" })
                                    }
                                    type="number"
                                    size="large"
                                    min={0}
                                    value={form.weight}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            weight: e.target.value,
                                        })
                                    }
                                />
                            </DBFieldBlock>
                            <DBFieldBlock
                                title={t("item.type.shared.photo.question")}
                                hint={t("item.type.shared.photo.hint")}
                                span={2}
                            >
                                <div className="item-type-switch-container">
                                    <DBSwitch
                                        checked={form.has_shared_photo}
                                        onChange={(checked) =>
                                            setForm({
                                                ...form,
                                                has_shared_photo: checked,
                                            })
                                        }
                                    />
                                </div>
                            </DBFieldBlock>
                            {form.has_shared_photo && (
                                <DBFieldBlock
                                    title={t("item.type.shared.photo.upload")}
                                    required
                                    error={formErr.photo}
                                    span={2}
                                >
                                    {form.photo ? (
                                        <div className="shared-photo-preview">
                                            <img
                                                src={form.photo}
                                                alt={t(
                                                    "item.type.shared.photo.upload"
                                                )}
                                            />
                                        </div>
                                    ) : null}
                                    <DBUpload
                                        accept=".jpg,.jpeg,.png"
                                        caption={
                                            form.photo
                                                ? t("items.delete.picture")
                                                : t("items.select.picture")
                                        }
                                        outlined
                                        type={
                                            form.photo ? "secondary" : "primary"
                                        }
                                        maxSize={1024 * 1024}
                                        onChange={async (e) => {
                                            setFormErr({
                                                ...formErr,
                                                photo: "",
                                            });
                                            setForm({
                                                ...form,
                                                photo: await toBase64(
                                                    e.target.files[0]
                                                ),
                                            });
                                        }}
                                        onClick={(e) => {
                                            if (form.photo) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setForm({
                                                    ...form,
                                                    photo: "",
                                                });
                                            }
                                        }}
                                    />
                                </DBFieldBlock>
                            )}
                        </div>
                        <DBModalTitle>
                            {t("item.type.main.automation.group")}
                        </DBModalTitle>
                        <div className="grid">
                            <DBFieldBlock
                                title={t("item.type.group")}
                                error={formErr.new_feedback_status_group}
                            >
                                <TreeSearchSelect
                                    status={
                                        formErr.new_feedback_status_group &&
                                        "error"
                                    }
                                    onClick={() =>
                                        setFormErr({
                                            ...formErr,
                                            new_feedback_status_group: "",
                                        })
                                    }
                                    data={automationGroups}
                                    size="large"
                                    value={form.new_feedback_status_group}
                                    onChange={(e) => {
                                        setForm({
                                            ...form,
                                            new_feedback_status_group: e,
                                        });
                                    }}
                                />
                            </DBFieldBlock>
                            <DBFieldBlock
                                title={t("item.type.close.group")}
                                error={formErr.close_feedback_status_groups}
                            >
                                <TreeSearchSelect
                                    status={
                                        formErr.close_feedback_status_groups &&
                                        "error"
                                    }
                                    onClick={() =>
                                        setFormErr({
                                            ...formErr,
                                            close_feedback_status_groups: "",
                                        })
                                    }
                                    data={automationGroups}
                                    size="large"
                                    value={form.close_feedback_status_groups}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            close_feedback_status_groups: e,
                                        })
                                    }
                                />
                            </DBFieldBlock>
                        </div>
                        <DBModalTitle>{t("item.type.language")}</DBModalTitle>
                        <div className="grid">
                            <DBFieldBlock title={t("item.type.name")}>
                                <DBInput
                                    type="text"
                                    size="large"
                                    value={language.name}
                                    onChange={(e) =>
                                        setLanguage({
                                            ...language,
                                            name: e.target.value,
                                        })
                                    }
                                />
                            </DBFieldBlock>
                            <DBFieldBlock
                                title={t("item.type.language.select")}
                            >
                                <div className="language-flex">
                                    <DBSelect
                                        value={language.language}
                                        onChange={(e) =>
                                            setLanguage({
                                                ...language,
                                                language: e,
                                            })
                                        }
                                        options={[
                                            {
                                                value: "en",
                                                label: t(
                                                    "item.type.language.en"
                                                ),
                                            },
                                            {
                                                value: "ar",
                                                label: t(
                                                    "item.type.language.ar"
                                                ),
                                            },
                                        ]}
                                        size="large"
                                    />
                                    <DBAddButton
                                        editMode={languageEditMode}
                                        onClick={addLanguageHandle}
                                        disabled={!language.name}
                                    />
                                </div>
                            </DBFieldBlock>
                        </div>
                        {form.translates.length > 0 && (
                            <div className="language-table">
                                <LanguageTable
                                    data={form.translates.map((item) => ({
                                        ...item,
                                        language:
                                            item.language === "en"
                                                ? t("item.type.language.en")
                                                : t("item.type.language.ar"),
                                    }))}
                                    onEdit={editLanguageHandle}
                                    onDelete={deleteLanguageHandle}
                                />
                            </div>
                        )}
                        <DBModalTitle>{t("item.type.more")}</DBModalTitle>
                        <DBFieldBlock title={t("item.type.description")}>
                            <DBTextArea
                                rows={4}
                                type="text"
                                size="large"
                                value={form.description}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        description: e.target.value,
                                    })
                                }
                            />
                        </DBFieldBlock>
                        <IncentiveQuickSetup
                            value={quickSetup}
                            onChange={setQuickSetup}
                            targetType="item_type"
                            partialFailure={Boolean(partialTarget)}
                            retrying={quickSaving}
                            onRetry={retryQuickSetup}
                        />
                    </>
                )}
            </DBModal.Content>
            <DBModal.Footer>
                <DBButton
                    caption={t("save")}
                    onClick={addEditItemType}
                    loading={sendItemTypeLoader || quickSaving}
                />
                <DBButton
                    caption={t("cancel")}
                    type="secondary"
                    onClick={onHide}
                />
            </DBModal.Footer>
        </DBModal>
    );
}
